var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortableGrid',{attrs:{"heroes":_vm.heroes,"columns":_vm.columns,"filterKey":_vm.filterKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }